import { getElcoConf } from '../modules/getElcoConf.js'
import { zgif } from '../modules/zgif.js'
import { SG1Logs } from '../modules/logs.js'

export const metadataOrchestrator = (value) => {
   try {

      const { SEO, partners, technical } = value.zones[0].data

      // title
      addHeadTag('title', SEO.title)

      // description
      addMeta('description', SEO.description)

      // robots
      addMeta('robots', 'index, follow')

      // Body classes
      if (technical.isUserLogged === true) document.body.classList.add('is-logged')
      document.body.classList.add(`is-${technical.deviceType}`)

      // Page Testid
      const testid = `${technical.pageId}`
      document.body.setAttribute('data-testid', testid)

      // canonical
      addHeadLink(SEO.canonicalURL, 'canonical')

      // facebook-domain-verification
      if (partners.facebooksiteverif !== '') addMeta('facebook-domain-verification', partners.facebooksiteverif)

      // google-domain-verification
      if (partners.googlesiteverif !== '') addMeta('google-site-verification', partners.googlesiteverif)

      // datastore
      addDataStore(technical.isUserLogged, getPageId(technical.pageId), technical.pageId, technical.deviceType, technical.featureFlags)

      // Optimise
      if (technical.featureFlags.pf_disable_partners === false && (technical.appEnv === 'dev' || technical.appEnv === 'staging' || technical.appEnv === 'preprod')) {
         addScript('', '', 'https://www.googleoptimize.com/optimize.js?id=OPT-PFKJTFV')
      }

      // dataLayer
      addDatalayer(getPageId(technical.pageId), technical.isUserLogged, technical.deviceType, technical.idTracking)

      // JSON LD
      addScript('application/ld+json', SEO.jsonLD)

      // Add PDB
      const pdbLoaded = () => {
         const pdbConfig = {
            prefix: 'adv',
            watchedAttributes: ['canal', 'cappingdata'],
            pixelURL: technical.adviseCappingURL,
            method: 'POST',
            plugin: 'adviseCapping'
         }
         try {
            if (window.dataStoreHP.SSEstatus === 'disconnected') {
               o_pdb.init(pdbConfig)
            } else {
               document.addEventListener('sseEndOfTransmition', () => {
                  o_pdb.init(pdbConfig)
               })
            }
         } catch (error) {
            console.error('Pdb capping error')
         }
      }

      // Add ELCO
      const elcoLoaded = () => {
         // WORKAROUND : Trigger le DOMContentLoaded pour déclencher le header des elcos
         window.document.dispatchEvent(new Event("DOMContentLoaded", {
            bubbles: true,
            cancelable: true
         }))

         if (typeof (head) !== 'undefined') {
            head.ready(function () {
               if (!technical.featureFlags.ff_disable_pdb) {
                  // il faut avoir les elco pour executer le capping advise
                  addScript('', '', 'https://gp.cdn.woopic.com/tools/pdb.min.js', pdbLoaded)
               }

               o_footer()

               const isSearchFormReady = document.getElementById('searchForm') !== null ? true : false
               if (isSearchFormReady) {
                  o_initCompletion()
                  o_generateSearchZone('searchForm', 'hp')
               } else {
                  document.addEventListener('generateSearchZone', (event) => {
                     o_initCompletion()
                     o_generateSearchZone('searchForm', 'hp')
                  }, { once: true })
               }
            })
         }
      }

      if (!technical.featureFlags.pf_disable_partners) {
         addElcoConf(technical.pageId, technical.appEnv)
         addScript('', '', 'https://c.woopic.com/libs/common/o_load_responsive.js', elcoLoaded)
         zgif(window.zgifJalons, window.dataStoreHP.zgif.app, window.dataStoreHP.zgif.access).run()
      }

      // Add AdGateway
      if (window.dataStoreHP.oanPageId !== '' && !technical.featureFlags.pf_disable_partners) {
         let tag = document.createElement('script')
         tag.src = `https://cdn.adgtw.orangeads.fr/mediation/${window.dataStoreHP.oanPageId}.js`
         tag.defer = true
         tag.dataset.testid = "script-pub"
         document.head.appendChild(tag)
      }

      // Add Cyclope
      if (technical.featureFlags.pf_cyclope) {
         addScript('', '', 'https://artifactory.si.francetelecom.fr/mfy-ftaccueilv-generic/cyclope/cyclope.user.js')
      }
   } catch (error) {
      console.error('metadata orchestrator', error)
      SG1Logs.incLog('Err_CORCH')
      SG1Logs.sentryEvent({ error: error, data: value, name: 'Metadata Orchestrator' })
   }
}

const addMeta = (name, content) => {
   const meta = document.querySelector(`meta[name="${name}"]`)
   if (meta) {
      meta.setAttribute('content', content)
   } else {
      const newMeta = document.createElement('meta')
      newMeta.name = name
      newMeta.content = content
      document.head.appendChild(newMeta)
   }
}

const addHeadTag = (type, content) => {
   let tag = document.querySelector(type)
   if (tag) {
      tag.textContent = content
   } else {
      tag = document.createElement(type)
      tag.textContent = content
      document.head.appendChild(tag)
   }
}

const addScript = (type = '', content = '', src = '', callback) => {
   let tag = document.createElement('script')
   src !== '' ? (tag.src = src) : ''
   type !== '' ? (tag.type = type) : ''
   content !== '' ? (tag.textContent = content) : ''
   typeof (callback) === 'function' ? tag.onload = callback : ''
   document.head.appendChild(tag)
}

const addHeadLink = (href, rel, type) => {
   let link = document.querySelector(`link[rel="${rel}"]`)
   if (link) {
      link.href = href
   } else {
      link = document.createElement('link')
      link.href = href
      link.rel = rel
      if (type) {
         link.type = type
      }
      document.head.appendChild(link)
   }
}

const addDataStore = (isUserLogged, pageId, refZ, deviceType, featureFlags) => {
   window.dataStoreHP.bandes ? '' : (window.dataStoreHP.bandes = {})
   window.dataStoreHP.featureFlags = {...window.dataStoreHP.featureFlags,...featureFlags}
   window.dataStoreHP.isLogged = isUserLogged
   window.dataStoreHP.pageId = pageId
   window.dataStoreHP.segRefZ = refZ
   window.dataStoreHP.device = deviceType
}

const getPageId = (refZ) => {
   let pageId = ''
   switch (refZ) {
      case 'regulier':
      case 'regulier-mob':
      case 'regulier-nl':
      case 'regulier-mob-nl':
         pageId = 'hp-regulier'
         break
      case 'occas':
      case 'occas-mob':
      case 'occas-nl':
      case 'occas-mob-nl':
         pageId = 'hp-occasionnel'
         break
      case 'prospect-nl':
      case 'prospect-mob-nl':
         pageId = 'hp-prospect'
         break

      case 'boutique-nl':
      case 'boutique-mob-nl':
         pageId = 'vitrine-boutique'
         break
      case 'boutique':
      case 'boutique-mob':
         pageId = 'vitrine-boutique-client'
         break

      case 'mobile-prospect-nl':
      case 'mobile-prospect-mob-nl':
      case 'mobile-prospect':
      case 'mobile-prospect-mob':
         pageId = 'n1-forfaits-prospect'
         break
      case 'mobile-client-nl':
      case 'mobile-client-mob-nl':
      case 'mobile-client':
      case 'mobile-client-mob':
         pageId = 'n1-forfaits'
         break

      case 'divert-prospect-nl':
      case 'divert-prospect-mob-nl':
      case 'divert-prospect':
      case 'divert-prospect-mob':
         pageId = 'n1-tv-prospect'
         break
      case 'divert-client-nl':
      case 'divert-client-mob-nl':
      case 'divert-client':
      case 'divert-client-mob':
         pageId = 'n1-tv'
         break
   }

   return pageId
}

const addDatalayer = (pageId, isUserLogged, deviceType, idTracking) => {
   switch (pageId) {
      case 'hp-regulier':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_regulier',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break
      case 'hp-occasionnel':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_occasionnel',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break
      case 'hp-prospect':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_prospect',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break

      case 'vitrine-boutique':
      case 'vitrine-boutique-client':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_mobile_client-mobile',
            type_page: 'cremaillere',
            univers_affichage: 'mobile',
         }
         break

      case 'n1-forfaits-prospect':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_mobile_prospect-mobile',
            type_page: 'cremaillere',
            univers_affichage: 'mobile',
         }
         break
      case 'n1-forfaits':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_mobile_client-mobile',
            type_page: 'cremaillere',
            univers_affichage: 'mobile',
         }
         break

      case 'n1-tv-prospect':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_divertissement_prospect-tv',
            type_page: 'cremaillere',
            univers_affichage: 'tv',
         }
         break
      case 'n1-tv':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_divertissement_client-tv',
            type_page: 'cremaillere',
            univers_affichage: 'tv',
         }
         break
   }
   window.o_data.id_tracking = idTracking
   window.o_data.segment = 'RES'
   window.o_data.sous_univers = 'global'
   window.o_data.canal = deviceType === 'mobile' ? 'Mobile Web' : 'Web'

   deviceType === 'mobile' ? (window.o_data.titre_page += '_webapp') : ''
   isUserLogged === true ? (window.o_data.titre_page += '_logue') : (window.o_data.titre_page += '_non_logue')
}

const addElcoConf = (refZ, appEnv) => {
   switch (refZ) {
      case 'regulier':
      case 'regulier-nl':
      case 'prospect-nl':
         window.o_confCommon = getElcoConf('prospect-regulier')
         break

      case 'regulier-mob':
      case 'regulier-mob-nl':
      case 'prospect-mob-nl':
         window.o_confCommon = getElcoConf('prospect-regulier-mob')
         break

      case 'occas':
      case 'occas-nl':
         window.o_confCommon = getElcoConf('occas')
         break

      case 'occas-mob':
      case 'occas-mob-nl':
         window.o_confCommon = getElcoConf('occas-mob')
         break

      case 'boutique-nl':
      case 'boutique':
         window.o_confCommon = getElcoConf('boutique')
         break

      case 'boutique-mob-nl':
      case 'boutique-mob':
         window.o_confCommon = getElcoConf('boutique-mob')
         break

      case 'mobile-prospect-nl':
      case 'mobile-prospect':
      case 'mobile-client-nl':
      case 'mobile-client':
         window.o_confCommon = getElcoConf('mobile')
         break

      case 'mobile-prospect-mob-nl':
      case 'mobile-prospect-mob':
      case 'mobile-client-mob-nl':
      case 'mobile-client-mob':
         window.o_confCommon = getElcoConf('mobile-mob')
         break

      case 'divert-prospect-nl':
      case 'divert-prospect':
      case 'divert-client-nl':
      case 'divert-client':
         window.o_confCommon = getElcoConf('divert')
         break

      case 'divert-prospect-mob-nl':
      case 'divert-prospect-mob':
      case 'divert-client-mob-nl':
      case 'divert-client-mob':
         window.o_confCommon = getElcoConf('divert-mob')
         break
   }
   window.o_confCommon.typeEnv = appEnv === 'dev' || appEnv === 'staging' || appEnv === 'preprod' ? 'rec' : 'prod'
   window.o_confCommon.tracking.refz.page = refZ
}
